<script setup lang="ts">
import { faListUl, faXmark } from '@fortawesome/pro-light-svg-icons'

const props = defineProps<{
  mode: 'open' | 'close'
  viewKey: string
  openLabel?: string
}>()

const { open, back } = useReadingView(props.viewKey)

function openToc(event: MouseEvent) {
  open('toc', event.currentTarget as HTMLElement)
}
</script>

<template>
  <div class="md:hidden flex items-center gap-2xs sticky top-0 z-10 bg-surface-elevated pb-xs mb-xs">
    <!-- The margin adds to the gap above the content without making the stuck bar taller. The sticky panels below it are offset for its 60px -->
    <ControlButton
      v-if="mode === 'open'"
      :icon="faListUl"
      :aria-label="openLabel ?? 'Åpne innhold'"
      class="min-w-11 h-11 hover:bg-surface-hover text-primary focus:outline-none focus:ring-2 focus:ring-blurple-300 p-0 bg-surface-primary"
      @click="openToc($event)"
    />
    <ControlButton
      v-else
      :icon="faXmark"
      aria-label="Lukk innhold"
      class="size-11 min-w-11 h-11 hover:bg-surface-hover text-primary focus:outline-none focus:ring-2 focus:ring-blurple-300 p-0 bg-surface-primary"
      @click="back()"
    />
    <slot />
  </div>
</template>
